import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_PROGRESS_TEST_OVERVIEW_REQUEST = 'FETCH_PROGRESS_TEST_OVERVIEW_REQUEST';
export const FETCH_PROGRESS_TEST_OVERVIEW_SUCCESS = 'FETCH_PROGRESS_TEST_OVERVIEW_SUCCESS';
export const FETCH_PROGRESS_TEST_OVERVIEW_FAILURE = 'FETCH_PROGRESS_TEST_OVERVIEW_FAILURE';

const buildProgressTestOverviewUrl = (groupId) =>
  buildUrl(`/groups/${groupId}/progress-test-overview`);

export function fetchProgressTestOverviewIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (!ApiCall.shouldPerform(state, { method: 'GET', url: buildProgressTestOverviewUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchProgressTestOverview(groupId));
  };
}

export function fetchProgressTestOverview(groupId) {
  return (dispatch) => {
    const url = buildProgressTestOverviewUrl(groupId);
    const method = 'GET';

    return dispatch(fetchProgressTestOverviewRequest()).payload
      .then((response) => dispatch(fetchProgressTestOverviewSuccess(response)))
      .catch((error) => dispatch(fetchProgressTestOverviewFailure(error)));

    function fetchProgressTestOverviewRequest() {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_OVERVIEW_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchProgressTestOverviewSuccess(overview) {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_OVERVIEW_SUCCESS,
        payload: overview,
        url,
        method,
        groupId,
      });
    }

    function fetchProgressTestOverviewFailure(error) {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_OVERVIEW_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/ProgressTestOverview/actions.js